import axios from 'axios';
import memoizee from 'memoizee';
import { authentication } from '../authentication';

import { logger } from '../logging';
import { FeatureOptions } from './useFeatureFlags';

let featureFlagServiceUrl = '/api/feature-flags-api/v1/feature-flags';

export const isFeatureFlagEnabled = async (options: FeatureOptions): Promise<boolean> => {
  const featureFlags = await getFeatureFlags();

  const isFeatureFlagEnabled = checkIfFeatureFlagIsEnabled(featureFlags, options);
  return isFeatureFlagEnabled;
};

const retrieveFeatureFlags = async (token: string, isBeta: boolean) => {
  const response = await axios.get(featureFlagServiceUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      beta: isBeta,
    },
  });
  return response?.data;
};
const memoizedAxiosCall = memoizee(retrieveFeatureFlags, { promise: true, maxAge: 10000 });
export const getFeatureFlags = async () => {
  try {
    if (!authentication.isAuthenticated) {
      return null;
    }

    const token = await authentication.getAccessToken();
    if (!token) {
      return null;
    }

    const isBeta = localStorage.getItem('gfknewron_feature_flag') === 'beta';

    const data = memoizedAxiosCall(token, isBeta);
    return data;
  } catch (error) {
    logger.error(error);
    return null;
  }
};

const checkIfFeatureFlagIsEnabled = (featureFlags: Record<string, unknown>, options: FeatureOptions) => {
  const featureFlag = featureFlags?.[options.domainName]?.[options.featureName];
  if (featureFlag && featureFlag.enabled) {
    return true;
  }

  return false;
};
